import { render, staticRenderFns } from "./SubscriptionVideos.vue?vue&type=template&id=64283c87"
import script from "./SubscriptionVideos.vue?vue&type=script&lang=js"
export * from "./SubscriptionVideos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports